window.imageGaleryBlock = function(obj) {
    if (obj.length === 0) {
        return {
            show: function () {
            },
            hide: function () {
            },
            error: true
        };
    }
    var $galleryUpBtn = obj.find('.js-gallery-up'),
        $galleryDownBtn = obj.find('.js-gallery-down'),
        $galleryDetailLeftBtn = obj.find('.js-gallery-detail-left'),
        $galleryDetailRightBtn = obj.find('.js-gallery-detail-right'),
        $galleryArrowBlock = obj.find('.js-gallery-arrow'),
        $thumbItem = obj.find('.js-thumb-item'),
        $thumbnailList = obj.find('.js-product-thumbnails'),
        $detailList = obj.find('.js-product-detail');


    var getThumbnailOptions = function () {
        return {
            arrows: false,
            vertical: true,
            dots: false,
            infinite: false,
            speed: 500,
            cssEase: 'linear',
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1240,
                    settings: {
                        arrows: false,
                        slidesToShow: 3,
                        vertical: false
                    }
                }
            ]
        };
    };
    var getDetailSlickOptions = function () {
        return {
            arrows: false,
            dots: false,
            speed: 1,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            useCSS: false,
            infinite: true,
            responsive: [
                {
                    breakpoint: 651,
                    settings: {
                        dots: true
                    }
                }
            ]
        };
    };
    var init = function () {

    };
    init();
    return {
        object: obj,
        $galleryDetailSlick: {},
        $galleryThumbnailSlick: {},
        error: false,
        init: function () {

        },
        show: function () {
            if ($thumbItem.length > 4) {
                $galleryArrowBlock.show();
            }

            this.$galleryDetailSlick = $detailList.slick(getDetailSlickOptions());
            this.$galleryThumbnailSlick = $thumbnailList.slick(getThumbnailOptions());
            var self = this;
            $galleryUpBtn.click(function () {
                self.$galleryThumbnailSlick.slick("slickPrev");
            });
            $galleryDownBtn.click(function () {
                self.$galleryThumbnailSlick.slick("slickNext");
            });

            $galleryDetailLeftBtn.click(function () {
                self.$galleryDetailSlick.slick("slickPrev");
            });
            $galleryDetailRightBtn.click(function () {
                self.$galleryDetailSlick.slick("slickNext");
            });
            $thumbItem.click(function () {
                self.$galleryDetailSlick.slick('slickGoTo', $(this).data('num'));
            });

        },
        hide: function () {

        }

    };
}


//////////////////
// WEBPACK FOOTER
// ./src/js/image_gallery.js
// module id = 2
// module chunks = 0 1 2